<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="success" dark v-bind="attrs" v-on="on">
        <!-- <v-icon>fas fa-plus</v-icon> -->
        PAYMENT
      </v-btn>
    </template>
    <v-card>
      <!-- <v-card-title> -->
      <v-toolbar :color="paymentColor">
        <v-chip
          pill
          color="teal darken-4"
          text-color="white"
          active-class="green"
        >
          <v-avatar
            size="avatarSize"
            color="white darken-2"
            class="black--text pa-4 my-4"
            left
          >
            <v-icon>
              fas fa-hand-holding-usd
            </v-icon>
          </v-avatar>
          {{ TotalPriceInCart.toLocaleString() }}
        </v-chip>

        <v-badge
          color="error darken-1"
          overlap
          :content="TotalQtyInCart.toLocaleString()"
        >
          <v-icon color="white">fas fa-cart-arrow-down</v-icon>
        </v-badge>

        <v-spacer></v-spacer>
        <v-btn @click="close" icon color="white">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- </v-card-title> -->
      <v-card-text class="pt-5">
        <v-form v-model="valid" ref="PaymentForm">
          <BaseDate
            v-model="SellDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>
          <v-text-field
            outlined
            v-model.trim="phone"
            @blur="FindCustome"
            @keyup.native.enter="FindCustome"
            :loading="isLoading"
            :label="isLoading ? 'Search Client' : 'Phone'"
            :disabled="isLoading"
            :rules="[v => !!v || 'Phone is required']"
            required
          ></v-text-field>
          <v-text-field
            outlined
            v-model.trim="Name"
            :disabled="!ShowName"
            label="Name"
            :rules="[v => !!v || 'customer name is required']"
            required
          ></v-text-field>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                reverse
                disabled
                outlined
                :value="DueAmount.toLocaleString()"
                label="Due Amount"
              ></v-text-field>
            </v-col>
            <v-col>
              <BaseNumInput
                outlined
                label="Discount"
                v-model.number="Discount"
              ></BaseNumInput>
            </v-col>
            <v-col>
              <BaseNumInput
                :rules="[paymentRule]"
                outlined
                label="Payed Amount"
                v-model.number="Amount"
              ></BaseNumInput>
            </v-col>
          </v-row>
          <v-row v-if="Remain" class="justify-center">
            <h3 class="text-decoration-underline">
              Blance:
              <Strong :class="Remain > 0 ? 'error--text' : ''"
                >( {{ Remain.toLocaleString() }} )</Strong
              >
            </h3>
          </v-row>
          <v-row>
            <v-col>
              <v-radio-group row v-model="cashType">
                <v-radio label="Cash" value="Cash"></v-radio>
                <v-radio label="Mobile" value="Mobile"></v-radio>
                <v-radio label="Bank" value="Main Bank"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="4" v-if="cashType !== 'Cash'">
              <v-text-field
                :rules="[v => !!v || 'Refrance required']"
                solo-inverted
                name="RefBank"
                label="Refrance"
                id="Refid"
                v-model="BankRef"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="isLoading && valid"
          color="success"
          @click="OnSavePayment"
          :disabled="!valid"
        >
          {{ "Save & Print" }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <PrintSale
      key="printKey"
      :clearData="clearData"
      :StoreInfo="StoreInfo"
      :StockType="SellType"
      v-model="print"
      :items="getCarts"
      :OrderPrint="orderCode"
      :client="{
        Name,
        phone,
        Amount,
        Discount,
        Remain,
        date: SellDate,
      }"
    >
    </PrintSale>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
// import printComp from "./printSale";

export default {
  components: {
    PrintSale: () => import("./printSale"),
    // PrintSale: printComp
  },
  props: {
    StoreInfo: [Object],
    TotalPriceInCart: { type: Number, required: true },
    SellType: { type: String, required: true },
  },

  data() {
    return {
      OrderPrint: "",
      ErrMsg: "",
      print: false,
      dialog: false,
      valid: true,
      isLoading: false,
      ShowName: false,
      phone: "",
      Name: "",
      SellDate: "",
      Localamount: 0,
      Discount: 0,
      cashType: "Cash",
      BankRef: "",
      clientID: null,
    };
  },
  computed: {
    ...mapGetters(["getCarts"]),
    orderCode: {
      get() {
        return this.OrderPrint;
      },
      set(v) {
        this.OrderPrint = v;
      },
    },
    paymentColor() {
      return this.SellType == "retail" ? "warning darken" : "teal darken-2";
    },
    Remain() {
      return this.DueAmount - this.Amount;
    },
    TotalQtyInCart() {
      return this.getCarts.reduce((total, item) => {
        return (total += item.qty);
      }, 0);
    },
    DueAmount() {
      return parseFloat((this.TotalPriceInCart - this.Discount).toFixed(2));
    },
    Amount: {
      get() {
        return this.Localamount;
      },
      set(val) {
        this.Localamount = val;
      },
    },
  },
  watch: {
    cashType() {
      this.BankRef = "";
    },
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          // this.SellDate = this.Current().date;
          // this.Amount = this.DueAmount;
          this.Amount = 0;
        });
      }
    },
    // Discount(value) {
    //   this.Amount = this.TotalPriceInCart - value;
    //   //   console.log(this.Amount);
    // }
  },
  methods: {
    paymentRule(val) {
      let amount = parseFloat(val.toString().replace(",", ""));
      if (this.DueAmount >= amount) return true;
      return "invalid Amount";
    },
    close() {
      this.Discount = 0;
      this.dialog = false;
      this.ShowName = false;
      this.ErrMsg = "";
      this.phone = "";
      this.Name = "";
      this.clientID = null;
      this.cashType = "Cash";
      this.orderCode = "";
      this.SellDate = "";
      this.$refs.PaymentForm.resetValidation();
    },
    clearData() {
      this.$store.commit("CLEAR_TO_CART");
      this.close();
    },

    OnSavePayment() {
      try {
        this.ErrMsg = "";
        if (this.$refs.PaymentForm.validate()) {
          //   console.log("validated");

          let data = {
            client: this.phone,
            // Name: this.ShowName ? this.Name : { _id: this.clientID },
            Name: this.clientID ? { _id: this.clientID } : this.Name,
            DueAmount: this.DueAmount,
            Paid: this.Amount,
            cashType: this.cashType,
            Discount: this.Discount,
            BankRef: this.BankRef,
            SellType: this.SellType,
            date: this.SellDate,
            time: this.Current().time,
          };
          this.isLoading = true;
          this.$store
            .dispatch("SellProduct", data)
            .then(orderCode => {
              // console.log(orderCode);
              this.orderCode = orderCode;
              this.isLoading = false;
              this.print = true;
            })
            .catch(err => {
              this.isLoading = false;
              this.ErrMsg = err;
            });
        }
      } catch (error) {
        console.log(error);
      }
    },

    FindCustome() {
      //   console.log("Called");
      this.clientID = null;
      this.Name = "";
      this.ShowName = false;
      if (!this.phone) return;
      if (this.isLoading) return;
      this.isLoading = true;
      let PhoneKey = { url: "/customer/find", query: { phone: this.phone } };
      this.$store
        .dispatch("FIND_BY_VALUE", PhoneKey)
        .then(({ data }) => {
          //   console.log(data);
          if (!data) this.ShowName = true;
          else {
            this.Name = data.Name;
            this.clientID = data._id;
          }
          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    },
  },
  //   updated() {
  //     this.Amount = this.TotalPriceInCart;
  //   }
};
</script>
